export default __webpack_public_path__ + "static/key-brain--blue-d53ed7b5bf1464e1739965fafb9b8260.webp";